import { render, staticRenderFns } from "./bank-history-block-list.vue?vue&type=template&id=00c536f6"
import script from "./bank-history-block-list.vue?vue&type=script&lang=ts"
export * from "./bank-history-block-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports